import React, { useState, useEffect, useContext,Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import { DatePickerInput } from "rc-datepicker";
import {Accordion, Card, FormGroup} from "react-bootstrap";
import { useParams } from "react-router-dom";
import "react-times/css/classic/default.css";
import ModalPop from 'components/sales/modal/modal';
import Images from 'assets/images/imageData';
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { set } from "date-fns";
import { Link } from "react-router-dom";
import './projectConfig.css';
import ReactStars from "react-rating-stars-component";
import {STATUS} from "../../constants/statusConstant";
import DivLayout from "../../components/sales/divLayout/divLayout";
import DocumentView from "../../components/sales/downloadDocView/documentView";


const styles = {
  fontFamily: "sans-serif",
  width: "500px",
  border: "1px solid #eee",
  background: "#f3f3f3",
  padding: "25px",
  margin: "20px",
};


const ProjectConfiguration = ({ match, history, createProjectConfig,getProjectConfig, projectDetails }) => {
  const { id } = useParams();
  const [modal, setModal] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [inputList, setInputList] = useState([
    {
      gate_number: "",
      gate_type: "",
      device: [{
        device_name: "",
        device_type: "",
      }],
    },
  ]);
  const [siteId, setSiteId] = useState(null);
  const [details, setDetails] = useState(null);

  useEffect(() => {
     if(match.params.id != undefined && match.params.id != null) {
         setSiteId(match.params.id);
     } 
  },[match.params.id]);
  // console.log('id ' + siteId);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getProjectConfig(match.params.id)
    })();
    setIsLoading(false);
  }, [getProjectConfig, match.params.id]);

  useEffect(() => {
    if (projectDetails && projectDetails?.data) {
      setDetails(projectDetails?.data);
    }
  }, [projectDetails]);

  const [inputList2, setInputList2] = useState([
    {
      entry_gates: "",
      exit_gates: "",
      entry_exit_gates: "",
      remark: "",
      site_type: "",
    },
  ]);

  const [inputList3, setInputList3] = useState([
    {
      device_name: "",
      device_type: "",
    },
  ]);
  const handleInputValue = (val, key) => {
    const list = [...inputList2];
    list[0][key] = val;
    setInputList2([...list]);
  };

  const handleInput2Value = (val, key, index) => {
    const list = [...inputList];
    list[index][key] = val;
    setInputList([...list]);
  };

  const handleInput3Value = (val, key, index, parentIndex, deviceKeyName) => {
    // console.log(parentIndex+" "+index+" "+key)
    const list = [...inputList];
    list[parentIndex][key][index][deviceKeyName] = val;
    setInputList3([...list]); 
  };
  // console.log('ip 3 ' + JSON.stringify(inputList3));
  const handledropDownChange = (e, name) => {
    const list = [...inputList2];
    list[0][name] = e;
    setInputList2(list);
  };

  const handleAddClick = (e) => {
    e.preventDefault();
      const newInput = {
        gate_number: "",
        gate_type: "",
        device: [{
          device_name: "",
          device_type: "",
        }],
      };
      const newList = [...inputList];
      newList.push(newInput);
      setInputList(newList);
  };

  const handleAddDevice = (e,index,parentIndex)=>
  {
    e.preventDefault();
    const newDevice = {
      device_name: "",
      device_type: "",
    };
    // const newList = [...inputList3];
    // const newListParent = [...inputList];
    // console.log(newListParent)
    setIsLoading(true)
    // console.log(parentIndex)
    inputList[parentIndex]['device'].push(newDevice)
    setInputList(inputList)
    setTimeout(() => {
      
      setIsLoading(false)
    }, 500)
    // newList.push(newDevice);
    // newListParent[parentIndex]['device'].push([...inputList3]);
    // setInputList3(newList);
    // setInputList(newListParent);
  };

  const handleRemoveDevice = (e,index,parentIndex) => {
    e.preventDefault();
    const newList = [...inputList3];
    const newListParent = [...inputList];
    newListParent[parentIndex]['device'].splice(index, 1);
    //newListParent.splice(index, 1);
    setInputList3(newList);
    setInputList(newListParent);
  };

  const handleRemoveClick = (e, index) => {
    e.preventDefault();
    
      let list = [...inputList];
      list.splice(index, 1);
      setInputList(list);
    
  };

  const handleSubmitForm = async () => {
    inputList2[0]["gate_details"] = inputList;
    inputList2[0]["siteId"] = siteId; 
    // console.log(inputList2);
    
    const res = await createProjectConfig(inputList2[0]);
    setIsLoading(false);
    
    if (res === true) {
      setModal(true);
    } else {
      setModal(false);
    }
  };
  

  {console.log(details)}
  return (
    <Layout
      title={localization.projectConfiguration}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/scheduled-meeting`}
    >
      {details !== null ?
        <Fragment>
          <div className="panel-card">
            <div className="panel-heading">{localization.projectConfiguration}</div>
            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={localization.noEntryGates}
                  data={
                    // localization.na
                    details?.entry_gates
                      ? details?.entry_gates
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.noExitGates}
                  data={
                    // localization.na
                    details?.exit_gates
                      ? details?.exit_gates
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.entry_exit_gates}
                  data={
                    // localization.na
                    details?.entry_exit_gates
                      ? details?.entry_exit_gates
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.remark}
                  data={
                    // localization.na
                    details?.remark
                      ? details?.remark
                      : localization.na
                  }
                />
                <DivLayout
                  heading={localization.pc_dropdown}
                  data={
                    // localization.na
                    details?.site_type
                      ? details?.site_type
                      : localization.na
                  }
                />

              </div>
            </div>
          <div className="panel-heading">{localization.gate_detail}</div>
          <div className="panel-body">
            <div className="details-listing">
              <Fragment>
                <Accordion defaultActiveKey="0" className="w-100">
                  {details &&
                    details?.gate_details &&
                    details?.gate_details.map((obj, index) => {
                      return (
                        <Card key={index + 1}>
                          <Card.Header>
                            <Accordion.Toggle
                              as={Card.Header}
                              variant="link"
                              eventKey={index + 1}
                            >
                              Gate {index + 1}
                            </Accordion.Toggle>
                          </Card.Header>
                          <Accordion.Collapse eventKey={index + 1}>
                            <Card.Body>
                              <div className="details-listing">
                                <DivLayout
                                  heading={localization.gate_number}
                                  data={
                                    obj?.gate_number
                                      ? obj.gate_number
                                      : localization.na
                                  }
                                />
                                <DivLayout
                                  heading={localization.gate_type}
                                  data={
                                    obj?.gate_type
                                      ? obj.gate_type
                                      : localization.na
                                  }
                                />
                              </div>
                              <hr/>
                              {obj?.device &&
                                <table className="table faq-listing table-bordered text-center">
                                  <thead className={"pc-head"}>
                                  <tr>
                                    <th>{localization.device_name}</th>
                                    <th>{localization.device_type}</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  {obj?.device.map((obj2, index2) => {
                                      return (
                                        <tr key={index2}>
                                          <td>{obj2?.device_name}</td>
                                          <td>{obj2?.device_type}</td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>

                              }
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      );
                    })}
                </Accordion>
              </Fragment>
            </div>
          </div>
          </div>
        </Fragment>
        :
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <ConstantInput
                    fullWidth
                    label={localization.noEntryGates}
                    type="number"
                    className="form-control"
                    id={`entry_gates`}
                    value={``}
                    isStarRequired={true}
                    handleChange={(value) => {
                      handleInputValue(value, "entry_gates");
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <ConstantInput
                    fullWidth
                    label={localization.noExitGates}
                    type="number"
                    className="form-control"
                    id={`exit_gates`}
                    value={``}
                    isStarRequired={true}
                    handleChange={(value) =>
                      handleInputValue(value, "exit_gates")
                    }
                  />
                </div>
                <div className="col-md-6">
                  <ConstantInput
                    fullWidth
                    label={localization.entry_exit_gates}
                    type="number"
                    className="form-control"
                    id={`entry_exit_gates`}
                    value={``}
                    isStarRequired={true}
                    handleChange={(value) =>
                      handleInputValue(value, "entry_exit_gates")
                    }
                  />
                </div>
                <div className="col-md-6">
                  <ConstantInput
                    fullWidth
                    label={localization.remark}
                    type="text"
                    className="form-control"
                    id={`remark`}
                    value={``}
                    handleChange={(value) => handleInputValue(value, "remark")}
                  />
                </div>

                <div className="col-md-6">
                  <DropDownInput
                    fullWidth
                    label={localization.pc_dropdown}
                    className="form-control"
                    isStarRequired={true}
                    data={[
                      {id: "old", name: "Old Site"},
                      {id: "new", name: "New Site"},
                    ]}
                    getIdValue={(val) => {
                      handledropDownChange(val.id, "site_type");
                    }}
                  />
                </div>
              </div>
              {inputList.map((input, index) => (
                <div className="row gate mt-3" key={index}>
                  <div className="col-md-4">
                    <ConstantInput
                      fullWidth
                      label={localization.gate_number + ` ${index + 1} `}
                      type="number"
                      className="form-control"
                      id={`gate_number${index}`}
                      value={input.gate_number}
                      handleChange={(value) =>
                        handleInput2Value(value, "gate_number", index)
                      }
                    />
                  </div>
                  <div className="col-md-4">
                    <ConstantInput
                      fullWidth
                      label={localization.gate_type}
                      type="text"
                      className="form-control"
                      id={`gate_type${index}`}
                      value={input.gate_type}
                      handleChange={(value) =>
                        handleInput2Value(value, "gate_type", index)
                      }
                    />
                  </div>
                  <div className="btn-box col-md-4 d-flex">
                    {inputList.length !== 1 && (
                      <div>
                        <button
                          onClick={(e) => handleRemoveClick(e, index)}
                          className="btn btn-sm btn-danger mr10"
                        >
                          Remove Gate
                        </button>
                      </div>
                    )}
                    {inputList.length - 1 === index && (
                      <div>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={(e) => handleAddClick(e)}
                        >
                          Add Gate
                        </button>
                      </div>
                    )}
                  </div>
                  <div className="card mx-3 mb-3">
                    <div className="card-body device-body">
                      {input.device.map((input3, index3) => (
                        <div className="row device" key={index3}>
                          <div className="col-md-4">
                            <ConstantInput
                              fullWidth
                              label={localization.device_name + ` ${index3 + 1} `}
                              type="text"
                              className="form-control"
                              id={`device_name${index3}-${index3}`}
                              value={input3.device_name}
                              handleChange={(value) =>
                                handleInput3Value(value, "device", index3, index, 'device_name')
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <ConstantInput
                              fullWidth
                              label={localization.device_type}
                              type="text"
                              className="form-control"
                              id={`device_type${index3}-${index3}`}
                              value={input3.device_type}
                              handleChange={(value) =>
                                handleInput3Value(
                                  value,
                                  "device",
                                  index3,
                                  index,
                                  'device_type'
                                )
                              }
                            />
                          </div>
                          <div className="btn-box col-md-4  mb-4 d-flex">
                            {input.device.length !== 1 && (
                              <div>
                                <button
                                  onClick={(e) =>
                                    handleRemoveDevice(e, index3, index)
                                  }
                                  className="btn btn-sm btn-danger mr10"
                                >
                                  Remove Device
                                </button>
                              </div>
                            )}
                            {input.device.length - 1 === index3 && (
                              <div>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={(e) =>
                                    handleAddDevice(e, index3, index)
                                  }
                                >
                                  Add Device
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
              <div style={{marginTop: "20px"}} className="col-md-12 col-sm-5">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() => {
                    handleSubmitForm();
                  }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      }

      <ModalPop
        title={'Check Out'}
        show={modal}
        handleModalHide={() => {
          setModal(false);
        }}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Gate Details Submitted Succsessfully</h5>
          {/* <div className="row">
          <div className="col-5"></div>
          <div className="col-4"> */}
          <Link to="/dashboard/site-listing" className="btn btn-primary mb-4">Go to Gate Listing</Link>
          {/* </div>
          </div> */}
        </div>
      </ModalPop>
    </Layout>
  );
};

export default ProjectConfiguration;